<article class="w-full rounded-3xl border border-gray-300 bg-white/95 p-5 sm:p-6">
  <div class="mb-5 flex items-center justify-between gap-3">
    <h3 class="text-base font-semibold text-slate-950">
      Latest posts
    </h3>
  </div>

  <div class="divide-y divide-gray-300">
    <article
      class="rounded-2xl bg-white/90 py-4 transition hover:bg-slate-50/80 sm:py-5"
      *ngFor="let post of posts"
    >
      <div class="grid grid-cols-1 gap-3">

        <div class="grid grid-cols-1 gap-3 sm:grid-cols-[112px_minmax(0,1fr)]">
          <div class="w-full shrink-0">
            <button
              type="button"
              class="aspect-video w-full cursor-pointer overflow-hidden rounded-xl border border-gray-300 bg-slate-100 transition hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-blue-200"
              [attr.aria-label]="'Open ' + post.title"
              (click)="openPost(post)"
            >
              <img
                class="h-full w-full object-cover"
                [src]="post.image"
                [alt]="post.title"
              />
            </button>
          </div>

          <div class="flex min-w-0 flex-col justify-start">
            <div
              role="heading"
              aria-level="3"
              class="line-clamp-2 text-[13px] font-medium leading-snug text-slate-950 sm:line-clamp-3 sm:text-[14px]"
              [matTooltip]="post.title"
            >
              {{ post.title }}
            </div>
          </div>
        </div>

        <div class="grid grid-cols-1 items-center gap-2 text-[11px] text-slate-600 sm:grid-cols-[112px_minmax(0,1fr)] sm:gap-3">
          <div class="flex min-w-0 items-center justify-start sm:justify-center">
            <span
              class="truncate px-1 text-[10px] font-semibold uppercase tracking-wide text-slate-500"
              [title]="post.domain"
            >
              {{ post.domain }}
            </span>
          </div>

          <div class="flex min-w-0 flex-wrap items-center gap-2">
            <span
              class="inline-flex max-w-[9rem] items-center justify-center truncate rounded-full border border-gray-300 bg-blue-50 px-2.5 py-1 text-[11px] font-semibold text-blue-700"
              [title]="post.platform"
              *ngIf="post.platform"
            >
              {{ post.platform }}
            </span>

            <button
              type="button"
              class="inline-flex cursor-pointer items-center justify-center rounded-full border border-gray-300 bg-white px-2.5 py-1 text-[11px] font-semibold text-slate-700 transition hover:bg-slate-50 hover:text-slate-950 focus:outline-none focus:ring-1 focus:ring-gray-300"
              (click)="openPost(post)"
            >
              View
            </button>
          </div>
        </div>

      </div>
    </article>
  </div>
</article>